// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import vueDrag from 'vue-dragging'
import {scrollBoard} from '@jiaminghi/data-view'
import 'element-ui/lib/theme-chalk/index.css'
Vue.config.productionTip = false

Vue.use(scrollBoard)
Vue.use(ElementUI)
Vue.use(vueDrag)
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js